import { forwardRef } from 'react';
import { StyledAccordionItem } from './styled';
import { useAccordionItem } from '../../../hooks/useAccordion';
import { AccordionItemProvider } from '../../../contexts/accordion';

const AccordionItem = forwardRef((props, ref) => {
  const { isOpen, bodyProps, triggerProps } = useAccordionItem();

  return (
    <AccordionItemProvider
      value={{
        isOpen,
        bodyProps,
        triggerProps,
      }}
    >
      <StyledAccordionItem ref={ref} {...props} />
    </AccordionItemProvider>
  );
});

export default AccordionItem;
